import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@traction/shared';
import { useAuth } from '@/contexts/AuthContext';
import { auth, sendEmailVerification } from '@/lib/firebase';
import { Mail } from 'lucide-react';

export function VerifyEmailPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [resending, setResending] = useState(false);
  const [resent, setResent] = useState(false);

  async function handleResend() {
    if (!user) return;
    setResending(true);

    try {
      await sendEmailVerification(user);
      setResent(true);
    } catch (error) {
      console.error('Failed to resend verification email:', error);
    } finally {
      setResending(false);
    }
  }

  async function handleCheckVerification() {
    await auth.currentUser?.reload();
    if (auth.currentUser?.emailVerified) {
      navigate(ROUTES.ONBOARDING);
    }
  }

  return (
    <div className="flex min-h-[calc(100vh-8rem)] items-center justify-center py-10 bg-cacao-dark">
      <div className="w-full max-w-sm px-4 text-center">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-cacao-dark-tertiary">
          <Mail className="h-5 w-5 text-cacao-gold" />
        </div>

        <h1 className="mt-5 font-heading text-lg font-medium text-[#F5F5F5]">Check your email</h1>
        <p className="mt-1.5 text-sm text-cacao-muted">
          We sent a verification link to <strong className="text-[#F5F5F5]">{user?.email}</strong>
        </p>

        <div className="mt-6 space-y-3">
          <button
            onClick={handleCheckVerification}
            className="w-full rounded-md bg-cacao-gold px-3 py-2 text-sm font-medium text-cacao-dark hover:bg-cacao-gold-hover transition-colors"
          >
            I verified my email
          </button>

          <button
            onClick={handleResend}
            disabled={resending || resent}
            className="w-full rounded-md border border-cacao-dark-tertiary bg-cacao-dark-secondary px-3 py-2 text-sm font-medium text-[#F5F5F5] hover:bg-cacao-dark-tertiary disabled:opacity-50 transition-colors"
          >
            {resent ? 'Email sent' : resending ? 'Sending...' : 'Resend email'}
          </button>
        </div>
      </div>
    </div>
  );
}
